<div class="container edit-vip-container">
  <div class="header">
    <div class="breadcrumb">{{ labels.controlPanel }} / {{ labels.editSeriesTitle }}</div>
    <div class="title-container">
      <span class="title">{{  labels.editSeriesTitle }} {{familyDto?.name}}</span>
      <app-region-selector></app-region-selector>
    </div>
  </div>
  <div class="divider"></div>
  <div class="body" [class.loading-active]="loading">
    <div *ngIf="vipLevels.length > 0" class="table">
      <div class="table-title">
        <span class="vip-title">Current Season</span>
        <div class="dates">
          <span><strong>{{labels.startsOn}}</strong> {{defineSeasonDates(VIPSeasonConstantObject.CURRENT).startsOn}}</span>
          <span><strong>{{labels.endsOn}}</strong> {{defineSeasonDates(VIPSeasonConstantObject.CURRENT).endsOn}}</span>
        </div>
      </div>
      <div class="table-header grid-current">
        <span>*</span>
        <span>{{labels.vipLevelName}}<span class="error">*</span></span>
        <span><span [innerHTML]="labels.inkRequired"></span><span class="error">*</span></span>
        <span>{{labels.discount}}(%)<span class="error">*</span></span>
      </div>
      <form [formGroup]="formVipCurrent">
        <div *ngFor="let vip of vipLevels" class="body-vip-modal grid-current">
          <span class="item">{{ getCurrentControlByVipType(vip.id, 'label').value }}</span>
          <app-input [control]="getCurrentControlByVipType(vip.id, 'name')"
                     disabled="true"
                     [errorHint]="false"
                     [formGroup]="formVipCurrent">
          </app-input>
          <app-input [control]="getCurrentControlByVipType(vip.id, 'levelPoints')"
                     disabled="true"
                     [errorHint]="false"
                     [formGroup]="formVipCurrent"
                     [type]="'number'">
          </app-input>
          <app-input [control]="getCurrentControlByVipType(vip.id, 'discount')"
                     disabled="true"
                     [errorHint]="false"
                     [formGroup]="formVipCurrent"
                     [type]="'number'">
          </app-input>
        </div>
      </form>
    </div>
    <div *ngIf="vipLevels.length > 0" class="table mf">
      <div class="table-title">
        <div class="table-display">
          <span class="vip-title">Next Season</span>
          <button class="action-button"
                  [ngClass]="{'action-button-selected': editEnabled}"
                  mat-icon-button
                  (click)="changeVIPEdit()">
            <nb-icon icon="edit-outline"></nb-icon>
          </button>

        </div>
        <div class="dates">
          <span><strong>{{labels.startsOn}}</strong> {{defineSeasonDates(VIPSeasonConstantObject.NEXT).startsOn}}</span>
          <span><strong>{{labels.endsOn}}</strong> {{defineSeasonDates(VIPSeasonConstantObject.NEXT).endsOn}}</span>
        </div>
      </div>
      <div class="table-header grid-next">
        <span>*</span>
        <span>{{labels.vipLevelName}}<span class="error">*</span></span>
        <span><span [innerHTML]="labels.inkRequired"></span><span class="error">*</span></span>
        <span>{{labels.discount}}(%)<span class="error">*</span></span>
      </div>
      <form [formGroup]="formVipNext">
        <div *ngFor="let vip of vipLevels" class="body-vip-modal grid-next" [class.marked]="vip.markedForDeletion">
          <span class="item">{{ getNextControlByVipType(vip.id, 'label').value }}</span>
          <app-input [control]="getNextControlByVipType(vip.id, 'name')"
                     [disabled]="!editEnabled || vip.markedForDeletion"
                     [errorHint]="false"
                     [formGroup]="formVipNext">
          </app-input>
          <app-input [control]="getNextControlByVipType(vip.id, 'levelPoints')"
                     [disabled]="!editEnabled || vip.markedForDeletion"
                     [errorHint]="false"
                     [formGroup]="formVipNext"
                     [type]="'number'">
          </app-input>
          <app-input [control]="getNextControlByVipType(vip.id, 'discount')"
                     [disabled]="!editEnabled || vip.markedForDeletion"
                     [errorHint]="false"
                     [formGroup]="formVipNext"
                     [type]="'number'">
          </app-input>
          <app-icon-click
            small
            *ngIf="!editEnabled"
            (click)="deleteBusinessLevel(vip)">
            {{ vip.markedForDeletion ? 'refresh' : 'delete' }}
          </app-icon-click>
        </div>
        <div class="generic-errors" *ngIf="formVipNext.invalid && formVipNext.touched">
          <ul>
            <li class="error" *ngFor="let msg of getGenericErrors()">{{ msg }}</li>
          </ul>
        </div>
      </form>
      <mat-checkbox color="primary"
                    *ngIf="editEnabled"
                    [(ngModel)]="allRegionsControl">
        <span [innerHTML]="labels.changesApplyAllRegions"></span>
      </mat-checkbox>
    </div>
    <div *ngIf="vipLevels.length <= 0" class="empty-list">
      <span >{{labels.emptyList}}</span>
    </div>
    <div *ngIf="loading" class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
  <div class="footer">
    <app-primary-button stroked (clickAction)="clickCancel()">{{ labels.cancel }}</app-primary-button>
    <button mat-flat-button color="primary" class="add-button mf" (click)="addNewLine()" *ngIf="!editEnabled">
      <nb-icon icon="plus-outline"></nb-icon>{{ labels.addVipLevel }}
    </button>
    <app-primary-button class="mf" *ngIf="editEnabled" (clickAction)="clickSave()" [disabled]="formVipNext.invalid">{{ labels.saveChanges }}</app-primary-button>
  </div>
</div>
